
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Chart from 'chart.js/auto';

@Component
export default class MetricCard extends Vue {
  @Prop({ required: true }) title!: string;
  @Prop({ required: true }) value!: number | string;
  @Prop() subtitle?: string;
  @Prop({ default: 'mdi-information' }) icon!: string;
  @Prop({ default: 'primary' }) color!: string;
  @Prop() trend?: number;
  @Prop() sparklineData?: number[];
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: true }) clickable!: boolean;

  chart: Chart | null = null;

  get formattedValue() {
    if (typeof this.value === 'number') {
      // Format large numbers with commas
      return this.value.toLocaleString('en-US');
    }
    return this.value;
  }

  get trendColor() {
    if (!this.trend) return 'grey';
    return this.trend > 0 ? 'success' : 'error';
  }

  get trendIcon() {
    if (!this.trend) return '';
    return this.trend > 0 ? 'mdi-trending-up' : 'mdi-trending-down';
  }

  handleClick() {
    if (this.clickable) {
      this.$emit('click');
    }
  }

  @Watch('sparklineData')
  onSparklineDataChange() {
    this.renderSparkline();
  }

  mounted() {
    if (this.sparklineData && this.sparklineData.length > 0) {
      this.renderSparkline();
    }
  }

  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  renderSparkline() {
    const canvas = this.$refs[`sparkline-${(this as any)._uid}`] as HTMLCanvasElement;
    if (!canvas || !this.sparklineData) return;

    // Destroy existing chart
    if (this.chart) {
      this.chart.destroy();
    }

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.sparklineData.map((_, i) => i),
        datasets: [{
          data: this.sparklineData,
          borderColor: this.color,
          borderWidth: 2,
          fill: false,
          pointRadius: 0,
          tension: 0.4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          }
        },
        scales: {
          x: {
            display: false
          },
          y: {
            display: false
          }
        },
        elements: {
          point: {
            radius: 0
          }
        }
      }
    });
  }
}
